import {bulkExportLinksOrderRepaired} from "../../../../../services/api/3dApi"

export default function () {
    window.open(bulkExportLinksOrderRepaired())
}
